
import React, {Component} from 'react'
import PropTypes from 'prop-types'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import { translate } from 'react-i18next'

import {FACTOR_EFFECTS} from '../../../constants'
import SliderComponent from '../slider2/Slider'
import StyledPaper from '../StyledPaper'



const styles = {
  label: {marginBottom: 50},
  factorPaperContainer: {marginBottom: 25},
  factorIndex: {fontSize: '1.15rem'}
}

class FactorEffectSlider extends Component {

  static sliderMarks = FACTOR_EFFECTS.text.reduce((accumulator, text, index) => {
    accumulator[index] = text
    return accumulator
  }, {})

  constructor(props) {
    super(props)
    this.state = {
      isInitialized: props.weight !== FACTOR_EFFECTS.uninitializedWeight,
      sliderIndex: this.getSliderIndex(props.weight),
    }
  }


  getSliderIndex(weight) {
    const index = FACTOR_EFFECTS.weights.indexOf(weight)
    return index === -1 ? null : index
  }

  handleChange = (sliderIndex) =>  {
    this.setState({isInitialized: true, sliderIndex})
    this.props.onChange(FACTOR_EFFECTS.weights[sliderIndex])
  }

  buildSliderMarks = () => {
    return Object.keys(FactorEffectSlider.sliderMarks).reduce((acc, key)=> {
      acc[key] = this.props.FactorEffectSlider.sliderMarks[key]
      return acc;
    }, {})
  }

  render() {

    const {label} = this.props


    return (
      <React.Fragment>
        <Grid container justify="center">
          <Grid item xs={12} style={styles.factorPaperContainer}>
            <StyledPaper style={styles.label}>
              <Typography style={styles.factorIndex} component="p">
                {label}
              </Typography>
            </StyledPaper>
          </Grid>
        </Grid>
        <Grid container justify="center">
          <Grid item xs={12}>
            <SliderComponent
              disabled={this.props.disabled}
              onChange={this.handleChange}
              value={this.state.sliderIndex}
              sliderTextType={"effectSlider"}
            />
          </Grid>
        </Grid>
      </React.Fragment>
    )
  }

}


FactorEffectSlider.propTypes = {
  disabled: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  weight: PropTypes.number.isRequired
}

export default translate()(FactorEffectSlider)


// WEBPACK FOOTER //
// ./src/components/counseling-session/factor-effect/FactorEffectSlider.js